module.exports = __webpack_public_path__ + "img/app03.0b8aef64.png";